import { ToastrService } from 'ngx-toastr';
import { ModalInfoOkComponent } from './../../../../shared/components/modals/info-ok/modal-info-ok.component';
import { FilterBpDTO } from 'src/app/shared/dtos/filterBpDTO';
import { SimpleQueryResponse } from './../../../../shared/dtos/simpleQueryResponse';
import { BpLineModel } from './../../../../shared/models/societe-linked/bp/bp-line.model';
import { SelectionModel } from '@angular/cdk/collections';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacyPaginator as MatPaginator, LegacyPageEvent as PageEvent } from '@angular/material/legacy-paginator';
import { Sort, MatSort, MatSortable } from '@angular/material/sort';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { Router } from '@angular/router';
import { ModalUpdateConfirmationComponent } from 'src/app/shared/components/modals/modal-update-confirmation/modal-update-confirmation.component';
import { BpModel } from 'src/app/shared/models/societe-linked/bp/bp.model';
import { BpService } from 'src/app/shared/services/bp/bp.service';
import { TrieTabService } from 'src/app/shared/services/utilities/trie-tab.service';
import { UtilisateurModel } from 'src/app/shared/models/utilisateur/utilisateur.model';
import { UserService } from 'src/app/shared/services/user.service';
import { BehaviorSubject, Observable, Subject, Subscription } from 'rxjs';
import { throttle } from 'rxjs/operators';
@Component({
  selector: 'app-bp-list',
  templateUrl: './bp-list.component.html',
  styleUrls: ['./bp-list.component.scss']
})
export class BpListComponent implements OnInit, OnChanges {

  displayedColumnsBP: string[] = ['selectRow', 'societe', 'codeSite', 'status', 'code', 'NBc', 'dBp',  'codeFourn',  'ttc',  'facture', 'bloque', 'numFacture', 'dFacture', 'codeCa1'];
  matDataSourceBP: MatTableDataSource<BpModel>;
  selection = new SelectionModel<BpModel>(true, []);
  sortState: Sort = { active: 'dBp', direction: 'asc' };
  pageSize = 50;
  pageIndex: number;
  length: number;
  dataSource: any[];
  selectedBps: BpModel[] = [];
  users: UtilisateurModel[] = [];
  private resObservable = new Subject<boolean>();

  @Input() datasource: BpModel[];
  @Input() filtreData: FilterBpDTO;
  @Input() simpleQueryBpResponse: SimpleQueryResponse<BpModel>;
  @Input() ifListAValide: boolean = false;
  @Output() selectedRowsEmit = new EventEmitter<BpModel[]>();

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort: MatSort;

  private paginationSubcription: Subscription;

  private paginationBp = new Subject<FilterBpDTO>();
  public pagination = this.paginationBp.asObservable();

  constructor(private triTabService: TrieTabService,
              private toastr: ToastrService,
              public dialog: MatDialog,
              private router: Router,
              private bpService: BpService,
              private userService: UserService) { }

  ngOnChanges(changes: SimpleChanges): void {
    // tslint:disable-next-line: max-line-length
    if (changes.datasource && changes.datasource.currentValue && changes.simpleQueryBpResponse && changes.simpleQueryBpResponse.currentValue) {
      this.dataSource = changes.datasource.currentValue.slice();
      this.matDataSourceBP = new MatTableDataSource(this.dataSource);
      this.length = this.simpleQueryBpResponse.count;
      this.pageIndex = this.simpleQueryBpResponse.pageNumber;
      this.pageSize = this.simpleQueryBpResponse.pageSize;
    }

    if (this.ifListAValide) {
      // tslint:disable-next-line: max-line-length
      this.displayedColumnsBP = ['selectRow', 'societe', 'codeSite', 'status', 'code', 'NBc', 'dBp',  'codeFourn',  'ttc',  'facture', 'bloque', 'numFacture', 'dFacture', 'codeCa1', 'trigrammeCreateur'];
    } else {
      // tslint:disable-next-line: max-line-length
      this.displayedColumnsBP = ['societe', 'codeSite', 'status', 'code', 'NBc', 'dBp',  'codeFourn',  'ttc',  'facture', 'bloque', 'numFacture', 'dFacture', 'codeCa1', 'trigrammeCreateur'];
    }
  }

  ngOnInit(): void {
    this.loadUsers();

    this.paginationSubcription = this.paginationBp.pipe(throttle(() => this.resObservable)).subscribe(result => { 
      this.bpService.getFiltredBp(this.filtreData).subscribe((data: SimpleQueryResponse<BpModel>) => {
        this.resObservable.next(true);
        this.simpleQueryBpResponse = data;
        this.dataSource = data.objets;
        // tslint:disable-next-line: max-line-length
        this.matDataSourceBP = new MatTableDataSource(this.dataSource);
        this.length = this.simpleQueryBpResponse.count;
        this.pageIndex = this.simpleQueryBpResponse.pageNumber;
        this.pageSize = this.simpleQueryBpResponse.pageSize;
      }, (error) => this.resObservable.next(false));
    });
  }

  distinct(bpLines: BpLineModel[]): BpLineModel[] {
    const result = [];
    const map = new Map();
    for (const item of bpLines) {
      if (item.bcLigne && item.bcLigne.bc) {
        if (!map.has(item.bcLigne.bc.code)){
          map.set(item.bcLigne.bc.code, true);
          result.push(item);
        }
      }
    }
    return result;
  }

  private loadUsers(): void {
    this.userService.getAll().subscribe((users) => {
      this.users = users;
    });
  }

  getAssociatedUser(bp: BpModel): string {
    const usr = this.users.find(x => x.id === bp.idCreateur);
    let str = '';
    if (usr) {
      str = usr.prenom + ' ' + usr.nom;
    }
    return str;
  }

  getAssociatedUserTrigram(bp: BpModel): string {
    const usr = this.users.find(x => x.id === bp.idCreateur);
    let str = '';
    if (usr) {
      str = usr.prenom.substring(0, 1).toUpperCase() + usr.nom.substring(0, 2).toUpperCase();
    }
    return str;
  }

  changePage(event?: PageEvent): void {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.filtreData.pageNumber = this.pageIndex;
    this.filtreData.pageSize = this.pageSize;
    this.loadPage();
  }

  trieTab(sort: Sort): void {
    if (sort.direction !== 'asc') {
      this.filtreData.descending = false;
    } else {
      this.filtreData.descending = true;
    }
    this.sortState = sort;
    this.filtreData.order = sort.active;
    this.loadPage();
  }

  loadPage(): void {
    this.paginationBp.next(this.filtreData);
  }

  editBP(bp: BpModel): void {
    const dialogRef = this.dialog.open(ModalUpdateConfirmationComponent, {
      data: {
        type: 'BP',
        statut: bp.status,
        message: 'Que souhaitez-vous réaliser sur cette facture ?',
        icone: 'warning_amber',
        iconColor: 'info',
        color: 'accent',
        idSociete: bp.idSociete,
        codeCa1: bp.codeCa1,
        nivStatus: bp.statusNum,
        listBp: true
      }
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        switch (res) {
          case 'Modifier Brouillon': {
            this.router.navigate(['create-bp/' + bp.id]);
            break;
          }
          case 'Voir': {
            this.router.navigate(['read-bp/' + bp.id]);
            break;
          }
          case 'Valider': {
            this.router.navigate(['validate-bp/' + bp.id]);
            break;
          }
          case 'Créer BP': {
            this.router.navigate(['create-bp/' + bp.id]);
            break;
          }
          case 'Facturer': {
            this.router.navigate(['facturation-bp/' + bp.id]);
            break;
          }
          case 'AnnulerBP': {
            const dialogConfirmation = this.dialog.open(ModalInfoOkComponent, {
              data: {
                title: 'Êtes-vous sûr de vouloir annuler cette facture ?',
                message: '',
                color: 'danger',
                type: ''
              }
            });
            return dialogConfirmation.afterClosed().subscribe((resultat) => {
              if (resultat) {
                this.bpService.cancel(bp).subscribe(() => {
                  this.loadPage();
                });
                this.toastr.success('Annulation de la facture ' + bp.code +  ' réussie');
              }
            });
          }
        }
      }
    });
  }

  /* Manage */
  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle(): void {
    if (this.isAllSelected()) {
      this.deleteBpRows();
      this.selection.clear();
    }
    else {
      if (this.ifListAValide) {
        this.matDataSourceBP.data.forEach(row => {
          // Si on ne trouve pas dans la sélection la ligne, on l'ajoute.
          if (!this.selectedBps.find(line => line === row)) {
            this.selection.select(row);
            this.setRowToBps(row);
          }
        });
      }
    }
    this.selectedRowsEmit.emit(this.selectedBps);
  }

  selectRow(row: BpModel): void {
    // On passe si la ligne est censée être désactivée
    this.selection.toggle(row);
    let currentBp: BpModel;
    if (row) {
      currentBp = this.selectedBps.find(model => model === row);
    }
    if (!currentBp) {
      this.setRowToBps(row);
    } else {
      this.deleteBpRow(row);
    }
    this.selectedRowsEmit.emit(this.selectedBps);
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected(): boolean {
    const numSelected = this.selection.selected.length;
    if (numSelected === 0) {
      return false; // Si il n'y a pas de lignes sélectionnées, on retourne faux ici
    }
    return this.length === numSelected;
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: BpModel): string {
    if (!row) {
      return `${!this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }

  /* Remove all checked items in bpArray  */
  deleteBpRows(): void {
    this.selectedBps = [];
  }

  /* Remove item in bpArray */
  deleteBpRow(row: BpModel): void {
    this.selectedBps.splice(this.selectedBps.findIndex(r => r === row), 1);
  }

  /* Add item into bpArray */
  setRowToBps(row: BpModel): void {
    this.selectedBps.push(row);
  }

}
